__turbopack_context__.v({
  "searchExpand": "MobileActions-module-scss-module__LBosGW__searchExpand",
  "searchExpandOtherActions": "MobileActions-module-scss-module__LBosGW__searchExpandOtherActions",
  "searchTermPadding": "MobileActions-module-scss-module__LBosGW__searchTermPadding",
  "sticky": "MobileActions-module-scss-module__LBosGW__sticky",
});
